function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D32F2F",
  d: "M38,42H10c-1.1,0-2-0.9-2-2V20h32v20C40,41.1,39.1,42,38,42z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F44336",
  d: "M42,20H6v-6c0-1.1,0.9-2,2-2h32c1.1,0,2,0.9,2,2V20z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 20,
  fill: "#FF8F00",
  width: 4,
  height: 22
})), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FF8F00",
  points: "32,6 28,6 22,12 26,12  "
}));

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFC107",
  points: "20,6 16,6 22,12 22,20 26,20 26,12 "
});

var SvgRewardSchemeIcon = function SvgRewardSchemeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRewardSchemeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reward_scheme_icon.0338c973.svg";
export { ForwardRef as ReactComponent };